/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form, Tab, Nav, Table, Alert } from "react-bootstrap";
import { Link, useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import { OccorrenzaForm } from "./occorrenza";
import { sports, tipologiaStruttura } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { Information } from "iconsax-react";
import UserCoursesTable from "../userCourses/index";
import UserCoursesTeamsTable from "../userCoursesTeams/index";
import ProductImageUploader from "../../../../components/Util/ProductImageUploader";
import { conMotivo } from "../../../../components/Util/erroreServer";
import { VAT_OPTIONS, findVatOption, vatFieldsFromOption } from "../../../../components/Util/vatOptions";
import { numeroDaTesto, prezzoPerCampo } from "../../../../components/Util/prezzi";

export const CoursesViewClosed = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    const { profile: profileData } = useProfile({ 
        autoFetch: true, 
        includeTitles: true 
    });
    const billingNotConfirmed = profileData && profileData?.club?.invoiceDataSender?.status !== 'CONFIRMED';
    const sdiEnabledNoVat = profileData?.club?.invoiceDataSender?.invoice_enabled === true && !profileData?.club?.invoiceDataSender?.vat_number;
    const priceFieldsLocked = (fieldName) => (fieldName === 'standard_price' || fieldName === 'iva_5_percent') && sdiEnabledNoVat;

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');

    const [enabledSports, setEnabledSports] = useState([]);

    useEffect(() => {
        if (profileData && profileData.club && profileData.club.sports) {
            const clubSports = profileData.club.sports.map(s => s.sportType);
            setEnabledSports(sports.filter(element => clubSports.includes(element.value)));
        }
    }, [profileData]);

    const [pictureModalShowed, setPictureModalShowed] = useState(false);





    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });


    // States for planning tab
    const [courseTeams, setCourseTeams] = useState([]);
    // Tab e squadra iniziali dall'indirizzo: tornando dalla modifica di un'occorrenza si riapre la Pianificazione sulla stessa squadra
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const tabIniziale = searchParams.get('tab') || 'informazioni';
    const [currentTeamIndex, setCurrentTeamIndex] = useState(parseInt(searchParams.get('squadra') || '0', 10) || 0);
    const [slotBookings, setSlotBookings] = useState([]);
    const [slotBookingsLoading, setSlotBookingsLoading] = useState(false);
    const [teamsLoading, setTeamsLoading] = useState(false);



	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const bookingCourses = await apiClient.getBookingCourseById(token, id);
					setLoadingShowed(false);
                    
                    if(bookingCourses) {
                        const elementFormData = {
                            id: bookingCourses.id,
                            clubId: bookingCourses.clubId,
                            name: bookingCourses.name, 
                            sportType: bookingCourses.sportType,
                            teamName: bookingCourses.teamName || '',
                            maxMembers: bookingCourses.maxMembers || 0,
                            type: bookingCourses.type || 'CLOSED',
                            standard_price: prezzoPerCampo(bookingCourses.standard_price),
                            member_price: prezzoPerCampo(bookingCourses.member_price),
                            federated_price: prezzoPerCampo(bookingCourses.federated_price),
                            fitcoin_cashback: bookingCourses.fitcoin_cashback,
                            payable_in_club: bookingCourses.payable_in_club,
                            payable_stripe: bookingCourses.payable_stripe,
                            payable_bank: bookingCourses.payable_bank,
                            vat_rate: bookingCourses.vat_rate,
                            vat_nature: bookingCourses.vat_nature,
                            iva_5_percent: bookingCourses.iva_5_percent,
                            status: bookingCourses.status,
                            description: bookingCourses.description,
                            coursePicture: bookingCourses.coursePicture,
                            coachId: bookingCourses.coachId || '',
                            venueId: bookingCourses.venueId || '',
                            startDate: bookingCourses.startDate || '',
                            endDate: bookingCourses.endDate || '',
                            weeklySchedule: bookingCourses.weeklySchedule || []
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
            setPaymentMethods({
                stripe_enabled: tokenDetails.stripe_enabled || false,
                bank_transfer_enabled: tokenDetails.bank_transfer_enabled || false
            });
        }
    }, [id]);

    // Fetch teachers and facilities

    const [formData, setFormData] = useState({
        id: '',
        clubId: '',
        name: '', 
        sportType: '',
        teamName: '',
        maxMembers: 0,
        type: 'CLOSED',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        vat_rate: 22,
        vat_nature: undefined,
        iva_5_percent: false,
        status: '',
        coursePicture: '',
        coachId: '',
        venueId: ''
    });

    // Titolo della pagina con il nome del corso (appena caricato)
    usePageTitle(formData?.name || null); // titolo = solo il nome del prodotto



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || false;
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSaveAll = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return;
            const tokenDetails = JSON.parse(tokenDetailsString);
            const token = tokenDetails.idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const updateData = {
                id: formData.id,
                clubId: formData.clubId,
                sportType: formData.sportType,
                name: formData.name,
                description: formData.description,
                maxMembers: parseInt(formData.maxMembers, 10) || 0,
                type: formData.type || 'CLOSED',
                status: formData.status,
                payable_in_club: formData.payable_in_club,
                payable_bank: formData.payable_bank,
                payable_stripe: formData.payable_stripe,
                vat_rate: formData.vat_rate,
                vat_nature: formData.vat_nature || undefined,
                iva_5_percent: formData.iva_5_percent,
                standard_price: numeroDaTesto(formData.standard_price) || 0,
                federated_price: numeroDaTesto(formData.federated_price) || 0,
                fitcoin_cashback: parseInt(formData.fitcoin_cashback, 10) || 0,
                teamName: formData.teamName,
                coursePicture: formData.coursePicture,
            };
            if (formData.newCoursePicture) {
                updateData.newCoursePicture = {
                    content: formData.newCoursePicture,
                    name: Math.random().toString(36).substring(2, 10) + (new Date()).getTime().toString(36),
                };
            }
            Object.keys(updateData).forEach(key => { if (updateData[key] === '') delete updateData[key]; });
            const result = await apiClient.updateBookingCourse(token, updateData);
            setLoadingShowed(false);

            if (result && result.error) {
                setModalTitle("Errore durante l'aggiornamento");
                setModalText(result.error);
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/courses');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error updating course:', error);
            setModalTitle("Errore durante l'aggiornamento");
            setModalText(conMotivo("Si è verificato un errore durante l'aggiornamento del corso."));
            setModalShowed(true);
        }
    };

    const renderEditableField = (fieldName, label, type = 'text', options = null, isBoolean = false) => {
        const value = formData[fieldName];
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked(fieldName);
        const disabledTitle = priceFieldsLocked(fieldName)
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        const disabledStyle = { color: 'var(--sid-text)', backgroundColor: '#f2f2f2', paddingLeft: '15px', fontWeight: 'normal' };

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">{label}</Form.Label>
                {options ? (
                    <Select
                        className="mt-2"
                        styles={sidSelectStyles}
                        isDisabled={disabled}
                        name={fieldName}
                        value={options.find(option => option.value === value)}
                        onChange={(selectedOption) =>
                            isBoolean
                                ? handleSelectChangeBoolean(selectedOption, fieldName)
                                : handleSelectChange(selectedOption, fieldName)
                        }
                        options={options}
                    />
                ) : type === 'textarea' ? (
                    <Form.Control
                        disabled={disabled}
                        as="textarea"
                        rows={10}
                        className="mt-2"
                        style={disabled ? disabledStyle : undefined}
                        name={fieldName}
                        value={value || ''}
                        onChange={handleChange}
                    />
                ) : (
                    <Form.Control
                        disabled={disabled}
                        className="mt-2"
                        style={disabled ? { ...disabledStyle, fontSize: '14px' } : undefined}
                        type={type === 'prezzo' ? 'text' : type}
                        inputMode={type === 'prezzo' ? 'decimal' : undefined}
                        name={fieldName}
                        value={(value || value === 0) ? value : ''}
                        onChange={handleChange}
                    />
                )}
            </div>
        );
    };

    // Campi si'/no: un interruttore su una riga, non una tendina in mezza colonna
    const renderSwitchField = (fieldName, label) => {
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        return (
            <div className="sid-switch-row" title={!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined}>
                <Form.Check
                    type="switch"
                    id={`switch-${fieldName}`}
                    label={label}
                    disabled={!isEditableStatus}
                    checked={!!formData[fieldName]}
                    onChange={(e) => setFormData(prev => ({ ...prev, [fieldName]: e.target.checked }))}
                />
            </div>
        );
    };


    // L'IVA non passa dal renderer generico: le opzioni a 0% differiscono per
    // codice Natura, quindi la voce selezionata non si trova confrontando un
    // singolo valore. Stessa logica di abilitazione degli altri campi prezzo.
    const renderVatField = () => {
        const isEditableStatus = formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED';
        const disabled = !isEditableStatus || priceFieldsLocked('iva_5_percent');
        const disabledTitle = priceFieldsLocked('iva_5_percent')
            ? 'Prezzo standard e IVA non modificabili senza partita IVA configurata'
            : (!isEditableStatus ? 'Modifica non disponibile per questo stato' : undefined);

        return (
            <div title={disabledTitle}>
                <Form.Label className="mb-2">IVA</Form.Label>
                <Select
                    className="mt-2"
                    styles={sidSelectStyles}
                    isDisabled={disabled}
                    name="vat_rate"
                    value={findVatOption(formData)}
                    onChange={(selectedOption) => setFormData(prev => ({ ...prev, ...vatFieldsFromOption(selectedOption) }))}
                    options={VAT_OPTIONS}
                />
            </div>
        );
    };

    // Eliminazione definitiva, disponibile anche a corso attivo o non attivo: il server
    // la rifiuta quando il corso ha lasciato tracce (iscrizioni, acquisti, presenze) e
    // in quel caso mostriamo il motivo che arriva da lui.
    const handleElimina = () => {
        setOnContinue(() => () => eliminaCorso());
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? Il corso sarà eliminato definitivamente dalla tua struttura. Non è possibile eliminarlo se ha iscrizioni, acquisti o presenze registrate: in quel caso puoi impostarlo come Non attivo.");
    };

    const eliminaCorso = async () => {
        setConfirmShowed(false);

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) {
                return;
            }
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const result = await apiClient.deleteBookingCourse(token, id);
            setLoadingShowed(false);

            if (!result || result.error) {
                setModalTitle("Eliminazione non riuscita");
                setModalText(result && result.error ? result.error : conMotivo("Si è verificato un errore durante la cancellazione"));
                setModalShowed(true);
            } else {
                navigate('/struttura/booking/courses');
            }
        } catch (error) {
            setLoadingShowed(false);
            console.error('Error in eliminaCorso: ' + error);
            setModalTitle("Eliminazione non riuscita");
            setModalText(conMotivo("Si è verificato un errore durante la cancellazione"));
            setModalShowed(true);
        }
    };

    // Stato dalla chip accanto al titolo: il cambio si registra subito e si resta nella scheda
    const cambiaStato = async (attiva) => {
        if (attiva && billingNotConfirmed) {
            setModalTitle("Documenti fiscali non ancora validati");
            setModalText("Non è possibile attivare la vendita di questo prodotto finché i documenti fiscali della tua struttura non sono stati validati. Per pubblicare prodotti e renderli acquistabili nell'App SportId Player devi prima configurare e confermare il metodo di fatturazione nella sezione La mia struttura → Documenti fiscali. Nel frattempo puoi continuare a creare prodotti e salvarli come bozza.");
            setModalShowed(true);
            return { annullato: true };
        }
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const result = await new MyApiClient().changeCourseStatus(token, id, nuovo);
        if (result && result.error) return { error: result.error };
        setFormData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: formData?.status === 'PURCHASABLE',
        bozza: formData?.status === 'DRAFT',
        onCambia: cambiaStato,
    });

    const goBack = () => {
        navigate('/struttura/booking/courses');
	};

    // Functions for planning tab
    const fetchCourseTeams = async () => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                setTeamsLoading(true);
                const result = await apiClient.getBookingCourseTeams(token, id);
                setTeamsLoading(false);

                if (result && !result.error) {
                    setCourseTeams(result);
                    // If we have teams and no current team is selected, fetch slot bookings for the first team
                    if (result.length > 0) {
                        const indice = Math.min(currentTeamIndex, result.length - 1);
                        if (indice !== currentTeamIndex) setCurrentTeamIndex(indice);
                        fetchSlotBookings(result[indice].id);
                    }
                } else {
                    console.error('Error fetching course teams:', result?.error);
                }
            }
        } catch (error) {
            console.error('Error fetching course teams:', error);
            setTeamsLoading(false);
        }
    };

    // Una riga della pianificazione apre (o chiude) sotto di se' il pannello di modifica dell'occorrenza
    const [occorrenzaAperta, setOccorrenzaAperta] = useState(null);
    const apriOccorrenza = (booking) => setOccorrenzaAperta((attuale) => (attuale === booking.id ? null : booking.id));

    const fetchSlotBookings = async (teamId) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                setSlotBookingsLoading(true);
                const result = await apiClient.getTeamSlotBookings(token, teamId);
                setSlotBookingsLoading(false);

                if (result && !result.error) {
                    setSlotBookings(result);
                } else {
                    console.error('Error fetching slot bookings:', result?.error);
                    setSlotBookings([]);
                }
            }
        } catch (error) {
            console.error('Error fetching slot bookings:', error);
            setSlotBookingsLoading(false);
            setSlotBookings([]);
        }
    };

    const handleTeamChange = (direction) => {
        if (courseTeams.length === 0) return;
        
        let newIndex;
        if (direction === 'next') {
            newIndex = currentTeamIndex < courseTeams.length - 1 ? currentTeamIndex + 1 : 0;
        } else {
            newIndex = currentTeamIndex > 0 ? currentTeamIndex - 1 : courseTeams.length - 1;
        }
        
        setCurrentTeamIndex(newIndex);
        fetchSlotBookings(courseTeams[newIndex].id);
    };

    // Formatting functions for planning tab


    // Squadre e sedute servono solo alla scheda Pianificazione: si chiedono quando la si apre
    // (e se si entra direttamente da un indirizzo con ?tab=pianificazione), non a ogni apertura
    // della scheda del corso.
    const [squadreChieste, setSquadreChieste] = useState(false);
    const caricaSquadreSeServe = (chiave) => {
        if (chiave !== 'pianificazione' || squadreChieste) return;
        setSquadreChieste(true);
        fetchCourseTeams();
    };
    useEffect(() => {
        if (tabIniziale === 'pianificazione') caricaSquadreSeServe('pianificazione');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, tabIniziale]);

	return (
		<>
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <ProductImageUploader
                show={pictureModalShowed}
                onClose={() => setPictureModalShowed(false)}
                onSave={(base64String) => {
                    setPictureModalShowed(false);
                    setFormData(prev => ({ ...prev, newCoursePicture: base64String }));
                }}
                titolo="Immagine del corso"
            />

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            {billingNotConfirmed && (
                <Alert variant="warning" className="d-flex align-items-start gap-2 text-dark" style={{ marginBottom: '1rem' }}>
                    <Information size="20" className="mt-1 flex-shrink-0" />
                    <div>
                        <strong>Metodo di fatturazione non configurato.</strong> Per pubblicare prodotti e renderli acquistabili nell'App SportId Player è necessario configurare e confermare il metodo di fatturazione nella sezione <strong>La mia struttura → Documenti fiscali</strong>. Puoi continuare a creare prodotti e salvarli come bozza.
                    </div>
                </Alert>
            )}

            <Row className="align-items-start mt-0">
                <div className="col-xl-12">
                    <div className="custom-tab-1">
                        <Tab.Container defaultActiveKey={tabIniziale} onSelect={caricaSquadreSeServe}>
                            <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="informazioni">
                                        Informazioni generali
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="acquisti">
                                        Partecipanti
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="squadre">
                                        Squadre
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="tabMenu">
                                    <Nav.Link eventKey="pianificazione">
                                        Pianificazione
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Row className="align-items-start mt-4">
                                <div className="col-12">
                                    <Tab.Content mountOnEnter>
                                        <Tab.Pane eventKey="informazioni">
                                            <Card>
                                                <Card.Body className="sid-card-body--spaced">
                                                    <Row className="g-4">
                                                        <Col md={6}>
                                                            <Form.Label>Tipo</Form.Label>
                                                            <div className="sid-readonly-value">{formData.type === 'CLOSED' ? 'Singolo' : 'Multiplo'}</div>
                                                        </Col>
                                                        <Col md={6}>
                                                            {renderEditableField('name', 'Nome corso', 'text')}
                                                        </Col>
                                                        <Col md={6}>
                                                            {renderEditableField('sportType', 'Tipologia di sport', 'select', enabledSports)}
                                                        </Col>
                                                        <Col md={12}>
                                                            {renderEditableField('description', 'Descrizione', 'textarea')}
                                                        </Col>
                                                        <Col md={12}>
                                                            <Form.Label>Foto</Form.Label>
                                                            <div className="sid-photo-field">
                                                                <div className="sid-photo-field__preview">
                                                                    {formData.newCoursePicture ?
                                                                        <img src={`data:image/jpeg;base64,${formData.newCoursePicture}`} alt="" />
                                                                    : formData.coursePicture ?
                                                                        <img src={formData.coursePicture} alt="" />
                                                                    :
                                                                        <span>Nessuna foto</span>
                                                                    }
                                                                </div>
                                                                {(formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED') && (
                                                                    <Button size="sm" variant="outline-dark" onClick={() => setPictureModalShowed(true)}>
                                                                        {(formData.newCoursePicture || formData.coursePicture) ? 'Sostituisci foto' : 'Carica foto'}
                                                                    </Button>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Prezzi</h5>
                                                    <Row className="g-4">
                                                        <Col md={3}>
                                                            {renderEditableField('standard_price', 'Prezzo standard', 'prezzo')}
                                                        </Col>
                                                        <Col md={3}>
                                                            {renderVatField()}
                                                        </Col>
                                                        {showingTesseratiOptions &&
                                                        <Col md={3}>
                                                            {renderEditableField('federated_price', 'Prezzo tesserati / soci', 'prezzo')}
                                                        </Col>
                                                        }
                                                        <Col md={3}>
                                                            {renderEditableField('fitcoin_cashback', 'Cashback Fitcoin', 'number')}
                                                        </Col>
                                                    </Row>

                                                    <h5 className="sid-form-section">Forme di pagamento</h5>
                                                    <div className="sid-switch-inline">
                                                        {renderSwitchField('payable_in_club', 'Acquisto pagabile in struttura')}
                                                        {paymentMethods.stripe_enabled && renderSwitchField('payable_stripe', 'Acquisto pagabile su Stripe')}
                                                        {paymentMethods.bank_transfer_enabled && renderSwitchField('payable_bank', 'Acquisto pagabile con bonifico')}
                                                    </div>

                                                </Card.Body>
                                            </Card>
                                        <div className="d-flex justify-content-between align-items-center gap-4 mt-4">
                                            <Link onClick={() => handleElimina()} to="#" className="btn btn-danger light">Elimina corso</Link>
                                            <div className="d-flex gap-4">
                                                <button type="button" className="btn btn-dark light" onClick={() => goBack()}>Indietro</button>
                                                {(formData.status === 'PURCHASABLE' || formData.status === 'CANCELLED') && (
                                                    <Button onClick={handleSaveAll} className="btn btn-primary">Salva</Button>
                                                )}
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="acquisti">
                                        <UserCoursesTable
                                            course_id={id}
                                            headerButtons={formData.status === 'PURCHASABLE' && (
                                                <Link to={`/struttura/booking/userCourses/new?courseId=${id}`} className="btn btn-primary btn-sm btn-add">
                                                    <i className="fas fa-plus me-2"></i>
                                                    Nuovo partecipante
                                                </Link>
                                            )}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="squadre">
                                        <UserCoursesTeamsTable bookingCourseId={id} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="pianificazione">
                                        <Card>
                                            <Card.Header>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h4 className="card-title mb-0">Pianificazione Squadre</h4>&nbsp;&nbsp;&nbsp;
                                                    {courseTeams.length > 0 && (
                                                        <div className="d-flex align-items-center gap-3">
                                                            <Button 
                                                                variant="outline-primary" 
                                                                size="sm"
                                                                onClick={() => handleTeamChange('prev')}
                                                                disabled={teamsLoading || courseTeams.length <= 1}
                                                            >
                                                                <i className="fas fa-chevron-left"></i>
                                                            </Button>
                                                            <span className="fw-bold">
                                                                {courseTeams[currentTeamIndex]?.name || 'Squadra'} 
                                                                <small className="text-muted ms-2">
                                                                    ({currentTeamIndex + 1} di {courseTeams.length})
                                                                </small>
                                                            </span>
                                                            <Button 
                                                                variant="outline-primary" 
                                                                size="sm"
                                                                onClick={() => handleTeamChange('next')}
                                                                disabled={teamsLoading || courseTeams.length <= 1}
                                                            >
                                                                <i className="fas fa-chevron-right"></i>
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                {teamsLoading ? (
                                                    <div className="text-center py-4">
                                                        <Spinner animation="border" role="status">
                                                            <span className="sr-only">Caricamento squadre...</span>
                                                        </Spinner>
                                                        <div className="mt-2">Caricamento squadre...</div>
                                                    </div>
                                                ) : courseTeams.length === 0 ? (
                                                    <div className="text-center py-4">
                                                        <i className="fas fa-users fa-3x text-muted mb-3"></i>
                                                        <h5 className="text-muted">Nessuna squadra trovata</h5>
                                                        <p className="text-muted">Non ci sono squadre associate a questo corso.</p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {slotBookingsLoading ? (
                                                            <div className="text-center py-4">
                                                                <Spinner animation="border" role="status">
                                                                    <span className="sr-only">Caricamento pianificazione...</span>
                                                                </Spinner>
                                                                <div className="mt-2">Caricamento pianificazione...</div>
                                                            </div>
                                                        ) : slotBookings.length === 0 ? (
                                                            <div className="text-center py-4">
                                                                <i className="fas fa-calendar-times fa-3x text-muted mb-3"></i>
                                                                <h5 className="text-muted">Nessuna pianificazione trovata</h5>
                                                                <p className="text-muted">Non ci sono slot prenotati per questa squadra.</p>
                                                            </div>
                                                        ) : (
                                                            <div className="table-responsive">
                                                                <table className="sid-plan-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Data</th>
                                                                            <th>Ora inizio</th>
                                                                            <th>Ora fine</th>
                                                                            <th>Impianto</th>
                                                                            <th>Maestro</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {slotBookings.map((booking, index) => {
                                                                            const inizio = new Date(booking.startDateTime);
                                                                            const fine = new Date(booking.endDateTime);
                                                                            const ora = (d) => d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
                                                                            return (
                                                                                // Tutta la riga apre la modifica della seduta
                                                                                <React.Fragment key={booking.id || index}>
                                                                                <tr
                                                                                    className={occorrenzaAperta === booking.id ? 'is-open' : undefined}
                                                                                    key={booking.id || index}
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    onClick={() => apriOccorrenza(booking)}
                                                                                    onKeyDown={(e) => { if (e.key === 'Enter') apriOccorrenza(booking); }}
                                                                                >
                                                                                    <td>
                                                                                        <div className="sid-plan-table__date">{inizio.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}</div>
                                                                                        <div className="sid-plan-table__day">{inizio.toLocaleDateString('it-IT', { weekday: 'long' })}</div>
                                                                                    </td>
                                                                                    <td>{ora(inizio)}</td>
                                                                                    <td>{ora(fine)}</td>
                                                                                    <td>{booking.venueName || '-'}</td>
                                                                                    <td>{booking.coachName || '-'}</td>
                                                                                </tr>
                                                                                {occorrenzaAperta === booking.id && (
                                                                                    <tr className="sid-plan-table__panel">
                                                                                        <td colSpan={5}>
                                                                                            <OccorrenzaForm
                                                                                                id={booking.id}
                                                                                                inPannello
                                                                                                onAnnulla={() => setOccorrenzaAperta(null)}
                                                                                                onSalvato={() => {
                                                                                                    setOccorrenzaAperta(null);
                                                                                                    const team = courseTeams[currentTeamIndex];
                                                                                                    if (team) fetchSlotBookings(team.id);
                                                                                                }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                                </React.Fragment>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Tab.Pane>
                                </Tab.Content>
                                 
                             </div>
                         </Row>
                         </Tab.Container>
                     </div>
                 </div>
             </Row>
		</>
	)

}
export default CoursesViewClosed;